import gql from 'graphql-tag'
import { getProvider } from '@/apollo'
import { splitError } from '@/helper/splitError'

const initialState = {
  params: {
    msisdn: '',
    activationCode: '',
    pPlusToken: null
  },
  orderByAgent: null,
  result: {},
  validationStatus: '',
  backendErrorCode: null,
  backendErrorMessage: null
}

const CheckoutInfoModule = {
  namespaced: true,
  state: initialState,
  getters: {
    msisdn: state => {
      return state.params.msisdn
    },
    params: state => {
      return state.params
    },
    result: state => {
      return state.result
    },
    activationCode: state => {
      return state.params.activationCode
    },
    resultType: state => {
      return state.result.type
    },
    market: state => {
      return state.result.details.market
    },
    tariffIdentifier: state => {
      return state.result?.details?.tariffIdentifier
    },
    tariffId: state => {
      return state.result?.details?.tariffId
    },
    orderByAgent: state => {
      return (state.orderByAgent !== null) ? true : null
    },
    webIdentPending: state => {
      return state.result?.details?.webIdentPending
    },
    retailerId: state => {
      return state.result?.details?.retailerId
    },
    validationStatus: state => state.validationStatus,
    backendErrorCode: state => state.backendErrorCode,
    backendErrorMessage: state => state.backendErrorMessage
  },
  mutations: {
    storeParams (state, params) {
      state.params = {
        ...state.params,
        ...params
      }
    },
    storeResult (state, result) {
      state.result = result
    },
    storeOrderByAgent: (state, orderByAgent) => {
      state.orderByAgent = orderByAgent
    },
    resetState (state) {
      Object.assign(state, initialState)
    },
    SET_VALIDATION_STATUS (state, status) {
      state.validationStatus = status
    },
    SET_BACKEND_ERROR_CODE (state, code) {
      state.backendErrorCode = code
    },
    SET_BACKEND_ERROR_MESSAGE (state, code) {
      state.backendErrorMessage = code
    }
  },
  actions: {
    async activationInfo ({ commit, state, rootGetters, getters }, { msisdn, activationCode, nextStep = 'personalDataInput', allowNextStep }) {
      commit('clearMessages', {}, { root: true })
      commit('storeParams', { msisdn, activationCode })
      commit('SET_VALIDATION_STATUS', 'STARTED')
      commit('SET_BACKEND_ERROR_CODE', null)
      commit('SET_BACKEND_ERROR_MESSAGE', null)
      const apolloClient = getProvider().defaultClient

      return apolloClient.mutate({
        mutation: gql`mutation activation ($activationInfoInput: ActivationInfoInput!){
          activationInfo (activationInfoInput: $activationInfoInput){
            type, details {
              contractId, market, creditBalance, subBrand, tariffIdentifier, webIdentPending, retailerId
              preactivatedTariff {
                tariffIdentifier name basicFee duration { amount unit }
              }
              activatableTariffs {
                allTariffOptions {
                  automaticExtension
                  duration {amount unit}
                  name
                  notBookableWith
                  phoneFlat
                  price
                  smsFlat
                  tariffoptionId
                }
                tariffId: tariffIdentifier
                name
                basicFee
                phoneFlat
                smsFlat
                runtime { amount unit }
                tariffOptions { tariffOptionId tariffOptionName notBookableWith price duration { amount unit }
                }
              }
            }
          }
        }`,
        variables: {
          activationInfoInput: {
            ...getters.params,
            brand: rootGetters.brand
          }
        }
      }).then((response) => {
        commit('SET_VALIDATION_STATUS', 'SUCCESS')
        commit('storeResult', response.data.activationInfo)
        return getters.resultType
      }).catch((error) => {
        let errorCode = 500
        let errorMessage = 'Es ist ein technischer Fehler aufgetreten.'

        // get error code and message
        if (splitError(error)[0].extensions.magma_code) {
          errorCode = splitError(error)[0].extensions.magma_code
        }
        if (splitError(error)[0].message) {
          errorMessage = splitError(error)[0].message
        }

        // if it's not a technical error, validation failed
        if (errorCode === 500) {
          commit('SET_VALIDATION_STATUS', 'ERROR')
        } else {
          commit('SET_VALIDATION_STATUS', 'FAILED')
        }

        // build error message
        if (errorMessage.indexOf(errorCode) === -1) {
          errorMessage = errorMessage + ' (Fehler: ' + errorCode + ')'
        }

        // update state
        commit('SET_BACKEND_ERROR_CODE', errorCode)
        commit('SET_BACKEND_ERROR_MESSAGE', errorMessage)

        splitError(error).forEach(e => commit('addError', e, { root: true }))
        throw error
      })
    }
  }
}

export default CheckoutInfoModule
